/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import {filesPost, FilesPostParams} from "../fn/file/files-post";
import {filesGet, FilesGetParams} from "../fn/file/files-get";

@Injectable({ providedIn: 'root' })
export class FileService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http);
    }

    /**
     * Uploads a file to the private storage bucket, and returns a guid referencing the file in the database
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    uploadFile$Response(params: FilesPostParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<string>> {
        return filesPost(this.http, this.rootUrl, params, headers, context);
    }

    /**
     * Get file from storage bucket
     *
     *
     *
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    getFile(params: FilesGetParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
        return filesGet(this.http, this.rootUrl, params, headers, context);
    }
}
